import React from 'react';
import './ProfileImage.css'; 

export default function ProfileImage() {
  return (
    <div className="photo">
      <img src="Images/IMG_9256.jpg" alt="Heli Kadakia" />

    </div>
  );
}
